import { PortalHelper } from "@/Common/Helpers/PortalHelper";
import { PortalSyncStatus } from "@/Common/Models/Portal/Enums/PortalSyncStatus";
import { SharedItem } from "@/Common/Models/Portal/SharedItem/SharedItem";
import { SharedItemMessage } from "@/Common/Models/Portal/SharedItem/SharedItemMessage";

class BasePortalShareableItem {
    public SharedItemId: string;
    public SharedItem: SharedItem;
    public SharedItemMessages: SharedItemMessage[];

    constructor(item?: Partial<BasePortalShareableItem>) {
        if (item?.SharedItemMessages) {
            for (const message of item.SharedItemMessages) {
                message.IsSelected ??= message.Status === PortalSyncStatus.Pending || message.Status === PortalSyncStatus.Viewed;
            }
        }
    }

    public getSharedItemId(): string {
        if (!this.SharedItem)
            return null;

        return this.SharedItem.SharedItemId;
    }

    public getSharedItem(): SharedItem {
        return this.SharedItem;
    }

    public getSharedItemMessages(): SharedItemMessage[] {
        this.SharedItemMessages && this.SharedItemMessages.forEach(p => {
            SharedItemMessage.init(p);
        });

        return this.SharedItemMessages;
    }

    public updateSharedItemMessages(sharedItemMessages: SharedItemMessage[]): void {
        sharedItemMessages.forEach(p => p.IsSelected = p.Status === PortalSyncStatus.Pending || p.Status === PortalSyncStatus.Viewed);
        this.SharedItemMessages = sharedItemMessages;
    }

    public getPortalStatus(): PortalSyncStatus {
        return this.getGlobalPortalStatus();
    }

    public getGlobalPortalStatus(): PortalSyncStatus {
        return PortalHelper.getGlobalPortalStatus(this.getSharedItem(), this.getSharedItemMessages());
    }

    public updateShareableModel(sharedItem: SharedItem, sharedItemMessages: SharedItemMessage[]): void {
        this.SharedItem = sharedItem;
        this.updateSharedItemMessages(sharedItemMessages);
    }

    public getSharedItemPortalStatus(): PortalSyncStatus {
        return PortalHelper.getLinkedItemPortalStatus(this.getSharedItem());
    }

    public getPortalStatusTooltip(): string {
        return "";
    }
}

export { BasePortalShareableItem };
